import React, { useEffect, useState } from "react";
import Table from "../../utilities/Table";
import axios from "axios";
import { orderColumns } from "../../utilities/utility";
import OrderCards from "../components/orders/OrderCards";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [completed, setCompleted] = useState(0);
  const [rejected, setrejected] = useState(0);
  const [pending, setPending] = useState(0);
  const [started, setstarted] = useState(0);
  const [cancelled, setCancelled] = useState(0);

  const setOrderCounts = async () => {
    const response = await axios.get("/api/orders");
    const order = await response.data;
    setOrders(order);
    const statusCounts = order.reduce((acc, item) => {
      acc[item.status] = (acc[item.status] || 0) + 1;
      return acc;
    }, {});
    setstarted(statusCounts.started || 0);
    setPending(statusCounts.accepted || 0);
    setrejected(statusCounts.rejected || 0);
    setCancelled(statusCounts.cancelled || 0);
    setCompleted(statusCounts.completed || 0);
  };

  useEffect(() => {
    setOrderCounts();
  }, []);

  return (
    <div className="wrapper wrapper-content">
      <OrderCards total={orders.length} completed={completed} started={started} pending={pending} rejected={rejected} cancelled={cancelled} />
      <Table title="Orders" data={orders} flag={true} columns={orderColumns} />
    </div>
  );
}
